export const FR = 'fr';
export const EN = 'en';
export const ES = 'es';
export const IT = 'it';
